import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import withSizes from 'react-sizes';
import FeaturedResources from '../components/VariantB/FeaturedResources';
import Search from '../components/Search';
import Intro from '../components/Intro';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ({ isIPad }) => (isIPad ? '32px 10px !important' : '32px 0px'),
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
    },
    [theme.breakpoints.down('1140')]: {
      padding: '24px 0',
    },
  },
  container: {
    marginTop: ({ isIPad }) => isIPad && '20px',
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },
    width: '100%',
    padding: '0 5%',
    '& > div': {
      [theme.breakpoints.down('xs')]: {
        padding: '7px 0 !important',
      },
    },
    [theme.breakpoints.down('1050')]: {
      padding: '0 2%',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '10px 18px',
    },
    [theme.breakpoints.down('sm')]: {
      '& > div': {
        padding: '16px 0 !important',
      },
    },
  },
  intro: {
    maxHeight: ({ isIPad }) => isIPad && '250px',
  },
}));

function VariantE({ isIPad }) {
  const classes = useStyles({ isIPad });
  return (
    <div className={classes.root} data-test-id="hero-variant-e">
      <Grid
        container
        className={classes.container}
        direction="row"
        spacing={4}
        alignItems="center"
      >
        <Grid
          item
          xs={isIPad ? 7 : 12}
          sm={isIPad ? 7 : 12}
          md={isIPad ? 7 : 5}
          className={classes.intro}
        >
          <Grid container>
            <Intro />
            <Grid item xs={12}>
              <Search />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={isIPad ? 12 : 7}>
          <FeaturedResources variant="E" isIPad={isIPad} />
        </Grid>
      </Grid>
    </div>
  );
}
const mapSizesToProps = ({ width }) => ({
  isIPad: width <= 1023 && width > 480,
});

export default withSizes(mapSizesToProps)(React.memo(VariantE));
